import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  ForwardRefRenderFunction,
} from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';

interface PreviewButtonProps {
  preview?: boolean;
  handleClosePreview: () => void;
  handlePreviewItem: () => Promise<void>;
}

export interface PreviewButtonRef {
  previewSelected: boolean;
  handleLoader: (isLoading: boolean) => void;
  handlePreviewSelected: (previewSelected: boolean) => void;
}

const PreviewButton: ForwardRefRenderFunction<
  PreviewButtonRef,
  PreviewButtonProps
> = ({ preview = false, handlePreviewItem, handleClosePreview }, ref) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [previewSelected, setPreviewSelected] = useState<boolean>(preview);

  const handleLoader = (isLoading: boolean) => setIsLoading(isLoading);

  const handlePreviewSelected = (previewSelected: boolean) =>
    setPreviewSelected(previewSelected);

  useImperativeHandle(ref, () => ({
    handleLoader,
    previewSelected,
    handlePreviewSelected,
  }));

  useEffect(() => {
    if (preview !== previewSelected) setPreviewSelected(preview);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preview]);

  return (
    <div>
      <Tooltip title={'Preview Trouble Tickets'} arrow placement="top">
        {!isLoading ? (
          !previewSelected ? (
            <IconButton
              size="small"
              sx={{ color: 'black' }}
              onClick={async () => {
                await handlePreviewItem();
                setPreviewSelected(true);
              }}
            >
              <VisibilityOff fontSize="small" />
            </IconButton>
          ) : (
            <IconButton size="small" color="warning">
              <Visibility
                fontSize="small"
                onClick={() => {
                  handleClosePreview();
                  setPreviewSelected(false);
                }}
              />
            </IconButton>
          )
        ) : (
          <React.Fragment />
        )}
      </Tooltip>
      {isLoading && <CircularProgress size={'1.125rem'} color="warning" />}
    </div>
  );
};

export default forwardRef<PreviewButtonRef, PreviewButtonProps>(PreviewButton);
